

import SharedOrderList from '@src/pages/shared/OrderList';
import { VouIdCode } from '@src/store/enums';
import { useSelector } from 'react-redux';

const ComplimentsOrderList = () => {
  const userAuthorizationGiftStatus = useSelector((state) => state?.user?.userAuthorizationGiftStatus);
  return <SharedOrderList vouId={VouIdCode.Compliments} isMarket={false} isCompliments={true} userAuthorizationStatus={userAuthorizationGiftStatus} />;
};

export default ComplimentsOrderList;
